import { Pipe, PipeTransform } from '@angular/core';
import { formatDocument } from '../utils/document.utils';

@Pipe({
  name: 'formatCnpj'
})
export class FormatCnpjPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    
    // Usa a função formatDocument que já suporta tanto CPF quanto CNPJ
    return formatDocument(value);
  }
}
